// `a` and `b` have at least one string in common
export function haveCommonString(a: string[], b: string[]): boolean {
  if (!a.length || !b.length) {
    return false;
  }
  const aSet = new Set(a);
  for (const bItem of b) {
    // for-loop so we can return early
    if (aSet.has(bItem)) {
      return true;
    }
  }
  return false;
}

// `a` contains all strings from `b`, i.e. `a` is a superset of `b`
export function containsAllStrings(a: string[], b: string[]): boolean {
  if (!b.length) {
    return true;
  }
  const aSet = new Set(a);
  for (const bItem of b) {
    // for-loop so we can return early
    if (!aSet.has(bItem)) {
      return false;
    }
  }
  return true;
}

export function removeAccents(text: string) {
  return (
    text
      .normalize('NFD')
      // biome-ignore lint/suspicious/noMisleadingCharacterClass: These are special diacritical characters
      .replace(/[\u0300-\u036f]/g, '')
  );
}

export const toTestId = (value: string): string =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
